import "./index.css";
import { Swiper, SwiperSlide } from "swiper/react";
import b from "../../assets/index4.png";
import c from "../../assets/index5.jpg";
import d from "../../assets/index6.jpg";
import company from "../../assets/company.png";
import Video from "../../assets/pc.mp4";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import News from "../News/index.js";
// import { useLocation } from "react-router-dom";

import { Pagination, Navigation, Autoplay } from "swiper";
import React, { useRef, useEffect, useState } from 'react';
export default function Index() {
  const [isPlaying, setIsPlaying] = useState(true);
  const videoRef = useRef(null);

  useEffect(() => {
    // if (videoRef && videoRef.current) {
    //   videoRef.current.onloadeddata = () => {
    //     setIsPlaying(true);
    //     videoRef.current.play();
    //   };
    // }
    // var video = document.querySelector('video');
    // console.log(video, 'video')
    // video.play()

  }, []);

  return (
    <div style={{ clear: "both" }}>
      <>
        <video
          // ref={videoRef}
          width="100%"
          height="700px"
          // controls
          autoPlay
          muted
          loop
          class="hide-controls"
        >
          <source src={Video} type="video/mp4" />
        </video>
        <div className="content">
          <div className="first">
            <h2>企业简介</h2>
            <div className="xian"></div>
            <div className="En">Company Profile</div>
            <div className="jianjie">
              <img src={company} alt="" />
              <p className="font">
                杭州中网智慧科技有限公司坐落于中国钱塘江畔的杭州国家高新技术产业开发区，在杭州滨江区和萧山区分别设有办公区，是中国领先的互联网、物联网、工业互联网智慧技术，计算机软件技术，智慧系统项目实施和数据运维技术整体解决方案提供商。致力于数字科技、信息安全、人工智能和新一代互联网智慧技术等领域的科学研究、技术开发和学术交流。依托浙江大学、浙江工业大学强大的科研和技术力量，形成了产学研一体的中国网络智慧技术研发、实施、管理和服务的卓越能力。
              </p>
            </div>
          </div>
          <div className="clear"></div>
        </div>
        <News />
      </>
    </div>
  );
}
